module.exports = '1.3.0';



//////////////////
// WEBPACK FOOTER
// /app/src/node_modules/sockjs-client/lib/version.js
// module id = pEac
// module chunks = 1